import { ContextualMenu, DefaultButton, IconButton, mergeStyleSets, Modal, PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useContext, useEffect, useRef, useState } from "react";
import { iconButtonStylesFunc } from "../../../../../components/Modal/ModalHeader";
import { CUSTOM_STYLES } from "../../../../../constants/Constants";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import { getHTMLTemplate } from "../../../../../service/StudyReportService";
import { defaultValueSetHRCTCovidChest, regenerateHRCTCovidReport } from "../../../helper/HRCTChestCovidUtilities";
import { circlStyle } from "../../../helper/initialData";
import "./modalStyle.css";

const HrctChestCovid = (props) => {

  const [htmlContent,setHTMLContent] = useState();
  const [loading,setLoading] = useState(false);
  const { getThemeColor,themeName } = useContext(themeContext);
  const containerRef = useRef(null);
  const {setModel,currentActiveTab,generateRSNAReportAPICall,alertSuccessModal,setAlertSuccessModal} = useContext(studyReportContext);

  const getHTMLTemplateCall = async(id)=>{
    setLoading(true);
    let res = await getHTMLTemplate(id);
    console.log("Resposne HTML ");
    console.log(res);
    if(res.status == 200){
      if(res.data.result == "SUCCESS"){
        let content = res.data.data.report;
        setHTMLContent(content);
        setLoading(false);
      }else{
        setLoading(false);
      }
    }
  }

  useEffect(()=>{
    console.log("IDD "+props.id);
      if(props.id != null && props.id != undefined){
          getHTMLTemplateCall(props.id);
      }
  },[props.id])

  useEffect(()=>{
      if(htmlContent != null && htmlContent != undefined && htmlContent != ""){
         defaultValueSetHRCTCovidChest();
      }
  },[htmlContent]);

 

  const {
    setReportModalState,
    reportModalState,
    regenerateHRCT
} = useContext(studyReportContext);

    const contentStyles =  mergeStyleSets({
      root:{
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        colorScheme:themeName==='light'?"none":"inherit",
     },
        container: {
          display: 'flex',
          width:'900px',
          height:'700px',
          overflowY:'hidden',
          overflowX:'hidden',
          borderRadius:'10px',
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: CUSTOM_STYLES.MODAL_BORDER,
          background: getThemeColor("modal-body")
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        header: [
          {
            display: 'flex',
            alignItems: 'center',
            //background:"#3B3A39",
            justifyContent: 'space-between',
            padding: '10px',
            background:getThemeColor("modal-header-footer"),
            cursor: "pointer"
          },
        ],
        footer:[
            {
                display: 'flex',
                justifyContent:"space-between",
                background:getThemeColor("modal-header-footer"),
                padding: '10px'
            }
        ]
      });
    
    const cancelIcon = { iconName: 'Cancel' }; 

    const regenerateHRCTReport = () => {
      let response = regenerateHRCTCovidReport();
      // if(response == null){
      //   return;
      // }


      if(response.error != null || response.error != undefined){
        setAlertSuccessModal(()=>{
          const newItem = {...alertSuccessModal};
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = response.message;
          return newItem;
        });
        return;
      }

      console.log(response);
      generateRSNAReportAPICall(response,props);
      // let tempContent = props.content;
      // tempContent.reportDetails.report = response;
      setReportModalState(() => {
          const newVal = { ...reportModalState };
          newVal.hrctChestILD = false;
          newVal.content = {};
          return newVal;
        });
        
     
      //regenerateHRCT(tempContent);
    }

    useEffect(() => {
      if (containerRef.current) {
        const elements = containerRef.current.querySelectorAll('.hrct-body select, .hrct-body textarea, .hrct-body input');
        if (elements.length > 0) {
          elements.forEach(element => {
            element.style.backgroundColor = getThemeColor("modal-body");
            element.style.color = getThemeColor("primary-color");
          });
        }
      }
    }, [htmlContent]);

    return (
        <Modal
        isOpen={props.isModalOpen}
        containerClassName={contentStyles.container}
        dragOptions= {{
            moveMenuItemText: "Move",
            closeMenuItemText: "Close",
            menu: ContextualMenu,
            dragHandleSelector: "#header-id",
            keepInBounds: true,
      }}
        styles={contentStyles}
      >
         {loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        {!loading && <>
        <div id="header-id" className={contentStyles.header}>
          <div id="rsna-title" style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">
            {props.content.text}
          </div>
          <IconButton
            styles={iconButtonStylesFunc(getThemeColor)}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={props.hideModal}
          />
        </div>
        <div ref={containerRef} id="covidSRPopupContext" style={{color: getThemeColor("primary-color"),accentColor:'rgb(0,117,255)'}} className="hrct-body modal-scroll-rsna" 
        dangerouslySetInnerHTML={{__html: htmlContent}}
        >
        </div>
        <div className={contentStyles.footer}>
            <div style={{display:'flex'}}>
                <DefaultButton text="Cancel" onClick={props.hideModal} />
                <PrimaryButton style={{marginLeft:'10px'}} text="Reset" onClick={()=>getHTMLTemplateCall(props.id)} />
            </div>
           
            <PrimaryButton text="Regenerate" onClick={()=>{
              
              regenerateHRCTReport();
              }} />
        </div></>
        }
      </Modal>
    )
}

export default HrctChestCovid;